/*
 * Created Date: Sunday October 31st 2021
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */
import { Breakpoint } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { CSSProperties } from "react";

export interface ModalCustomProps {
  header: string;
  onClose?: any;
  open: boolean;
  body?: any;
  actions?: any;
  maxWidth?: Breakpoint;
  sx?: CSSProperties;
}

const ModalCustom = ({
  header,
  onClose,
  open,
  body,
  actions,
  maxWidth,
  sx,
}: ModalCustomProps) => {
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={maxWidth ? true : false}
      maxWidth={maxWidth}
      sx={sx}
    >
      <DialogTitle onClose={onClose}>{header}</DialogTitle>
      <MuiDialogContent sx={{ backgroundColor: "background.default" }} dividers>
        {body ? body : null}
      </MuiDialogContent>
      <MuiDialogActions
        sx={{
          backgroundColor: "background.default",
          padding: 3,
          gap: 0.5,
        }}
      >
        {actions ? actions : null}
      </MuiDialogActions>
    </Dialog>
  );
};

const DialogTitle = (props?: any) => {
  const { children, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      sx={{
        backgroundColor: "background.default",
        display: "flex",
        flexDirection: "row",
        alignItems: "end",
        justifyContent: "space-between",
      }}
      variant="h5"
      {...other}
    >
      {children}
      {onClose && (
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
};

export default ModalCustom;
